<template>
    <card>
      <template class="card-header" slot="header">
        <h4 class="card-title">
          Database Information
          <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
            <font-awesome-icon icon="sync"></font-awesome-icon>
          </button>
        </h4>
        <p class="card-category">General information about the database used for this application.</p>
      </template>
      <table class="table table-borderless beast-info-table">
        <tr v-if="!noEnv">
          <th class="beast-key">Environment:</th>
          <td class="beast-value">{{dbInfo.environment}}</td>
        </tr>
        <tr>
          <th class="beast-key">Type:</th>
          <td class="beast-value">{{dbInfo.dbType}}</td>
        </tr>
        <tr>
          <th class="beast-key">Host:</th>
          <td class="beast-value">{{dbInfo.dbHost}}</td>
        </tr>
        <tr>
          <th class="beast-key">Database:</th>
          <td class="beast-value">{{dbInfo.dbDatabase}}</td>
        </tr>
      </table>
    </card>
</template>

<script>
export default {
  props: {
    dbInfo: {
      type: Object,
      required: true
    },
    noEnv: {
      type: Boolean,
      default: false
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  name: "DBInfo"
};
</script>

<style scoped>

</style>
